import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "status",
  component: withAsyncRouteLoading(() =>
    Promise.all([import(/* webpackChunkName: "status" */ "./components")]).then(
      ([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      }
    )
  ),
  childRoutes: [],
});
